<template>
  <div class="fabulous">
    <div class="fabulous-title">
      <span>{{this.$service.getCount(count.viewCount)}} professionals have visited</span>
    </div>
    <div class="img_wrap" style="margin-top: 0.12rem;">
        <template v-for="(item,index) in FollowList">
          <div class="vis_div" :key="index">
            <div class="flag-icon vis_img " :class="'flag-icon-'+item.countryCode"></div>
            <p>{{wCount(item.viewCount)}}</p>
          </div>
            <!-- <img :src="item.avatarUrl" class="avatarUrl" v-if="item.avatarUrl" :key="index"/>
            <span class="flag-icon avatarUrl" v-else-if="item.ipFlagStyle" :class="'flag-icon-'+item.ipFlagStyle" :key="index"></span>
            <img  src="@assets/img/empty.png" class="avatarUrl" v-else :key="index" /> -->
        </template>
    </div>
    <div class="more-avatarUrl"  v-if="!Followfinished" style="text-align: center">
      <div class="more_wrap" @click="visitMore">
        <span class="more-btn">MORE</span>
        <i class="iconfont icon-right-fill icon"></i>
      </div>
    </div>
    <div
      class="u-heart-theme"
      style="margin-top:0.7rem;margin-bottom: 0.32rem;color:#213c7b"
    >
      <div class="dot-box">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div  class="icon iconfont icon-dianzan"  @click="likeClick"  v-if="!islike"></div>
      <div class="like_img" v-else @click="likeClick">
        <img src="@/assets/img/new/like_ty.png" >
      </div>
    </div>
    <div class="dianzan">
      <span>{{wCount(count.likeCount)}} professionals like(s)</span>
    </div>
    <div class="userName img_wrap">
      <div class="vis_div" :key="index" v-for="(item, index) in ZanList">
        <div class="flag-icon vis_img " :class="'flag-icon-'+item.countryCode"></div>
        <p>{{wCount(item.likeCount)}}</p>
      </div>
      <!-- <span v-for="(item,index) in ZanList" :key="index">{{item.nickName || 'visitor'}}，</span> -->
      <div class="more-avatarUrl" v-if="!Zanfinished">
        <div class="more_wrap" @click="likeMore">
          <span class="more-btn">MORE</span>
          <i class="iconfont icon-right-fill icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import gql from 'graphql-tag'
export default {
    name: "live-follow",
    props:['islike','userCount','likeCount'],
    data() {
      return {
        Zanfinished: false,
        ZanpageIndex:1,
        ZanpageSize:30,
        ZanList:[],
        Followfinished: false,
        FollowpageIndex:1,
        FollowpageSize:20,
        FollowList:[],
        queryActivityLike:{},
        queryActivityView:{},
        total:0,
        likeTotal:0,
        count:{
          likeCount:0,
          viewCount:0,
          userCount:0
        }
      };
    },
    computed:{
        query() {
            return this.$router.history.current.query;
        },
        followGql(){
            return  gql`query ($query: _Any!) {
            ipActionCountQueryViewAct: ipActionCountQuery {
              page(query:$query){
                hasNextPage
                pageIndex
                totalCount
                items {
                  id
                  country
                  countryCode
                  likeCount
                  targetType
                  viewCount
                }
              }
            }
        }`
        },
        zanGql(){
            return  gql`query ($query: _Any!) {
            ipActionCountQueryAct: ipActionCountQuery {
              page(query:$query){
                hasNextPage
                pageIndex
                totalCount
                items {
                  id
                  country
                  countryCode
                  likeCount
                  targetType
                  viewCount
                }
              }
            }
        }`
        }
    },
    created(){
        this.init();
    },
    methods:{
        ...mapActions({
          graphqlPost: "en/graphqlPostByZXS", //阿波罗接口方法
        }),
        init(){
            this.getFollowList();
            this.getZanList();
            this.allCount();
        },
        async allCount(){
          let query=`
            {
              ipActionCountQuery {
                sumIp(targetType: "activity", targetId: "${this.query.actId}") {
                  userCount
                  viewCount
                  likeCount
                }
              }
            }
          `
          let opt = {
            query: query,
            variables: {},
          };
          let data = await this.graphqlPost(opt);
          let res=JSON.parse(JSON.stringify(data.data.ipActionCountQuery.sumIp));
          if(res){
            this.count=res;
          }
        },
        getFollowList(){
          let where = {
            Equal: {
              n: "targetId",
              v: this.query.actId,
            },
            Equal_targetType: {
              n: "targetType",
              v: 'activity',
            },
            GreaterThan: {
              n: "viewCount",
              v: 0,
            },
          };
          let order = [
            {
              N: "viewCount",
              v: 0,
            },
          ];
          let opt={
              page: this.FollowpageIndex,
              size: this.FollowpageSize,
              where: where,
              order: order,
          }
            this.$apollo.addSmartQuery('ipActionCountQueryViewAct', {
                query:this.followGql, 
                variables: {
                  query:opt
                },
                fetchPolicy:'no-cache',  // 清除缓存的数据，重新获取服务器数据
                result(data) {
                  let res =JSON.parse(JSON.stringify(data.data.ipActionCountQueryViewAct.page));
                    if(res.items){
                        let currentList = res.items;
                        currentList.map(el=>{
                          el.countryCode=el.countryCode.toLowerCase()
                        })
                        if(this.FollowpageIndex == 1){
                            this.FollowList = currentList;
                        } else {
                            this.FollowList = [...this.FollowList,...currentList]
                        }
                        if (!res.hasNextPage) {
                            this.Followfinished = true;
                        }
                        this.total = res.totalCount
                    }
                    console.log(this.FollowList,this.Followfinished,'围观人数')
                },// 错误处理
                error(error) {
                    console.error(error,'error错误处理')
                }
            })
        },
        getZanList(){
          let where = {
            Equal: {
              n: "targetId",
              v: this.query.actId,
            },
            Equal_targetType: {
              n: "targetType",
              v: 'activity',
            },
            GreaterThan: {
              n: "likeCount",
              v: 0,
            },
          };
          let order = [
            {
              N: "likeCount",
              v: 0,
            },
          ];
            let opt={
              page:this.ZanpageIndex,
              size:this.ZanpageSize,
              where: where,
              order: order,
          }
            this.$apollo.addSmartQuery('ipActionCountQueryAct', {
                query:this.zanGql, 
                variables: {
                    query:opt
                },
                fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
                result(data) {
                  let res =JSON.parse(JSON.stringify(data.data.ipActionCountQueryAct.page));
                    if(res.items){
                        let currentList = res.items;
                        currentList.map(el=>{
                          el.countryCode=el.countryCode.toLowerCase()
                        })
                        if(this.ZanpageIndex == 1){
                            this.ZanList = currentList;
                        } else {
                            this.ZanList = [...this.ZanList,...currentList]
                        }
                        if (!res.hasNextPage) {
                            this.Zanfinished = true;
                        }
                    }
                    this.likeTotal=res.totalCount
                    console.log(this.ZanList,this.Zanfinished,'点赞人数')
                },// 错误处理
                error(error) {
                    console.error(error,'error错误处理')
                }
            })
        },
       //访问更多点击
        visitMore(){
            if (this.Followfinished) return;
            this.FollowpageIndex += 1;
            this.getFollowList();
        },
        //点赞更多点击
        likeMore(){
            if (this.Zanfinished) return;
            this.ZanpageIndex += 1;
            this.getZanList();
        },
        //点赞点击
        likeClick(){
            this.$emit("addlike", 'zan');
        },
        addZan(){
          this.ZanpageIndex = 1,
          this.ZanList = [];
          this.getZanList();
        },
        wCount(value) {
          //过万处理
          let num = value;
          if (value > 9999) {
            //大于9999显示x.xx万
            num = Math.floor(value / 100) / 100 + "w";
          } else {
            num = value;
          }
          return num;
        },
    }
  };
</script>

<style scoped lang="scss">
  .fabulous {
    background-color: #fff;
    margin-top: 0.2rem;
    padding: 0.4rem 0.5rem  1rem 0.45rem;
    &.is_invitation{
      padding: 0.4rem 0.56rem 0.45rem;
      border-radius: 0.3rem;
      .img_wrap{
        margin-left: -0.16rem;
      }
      .avatarUrl{
        margin-left: 0.16rem;
      }
      .userName{
        
        &.img_wrap{
          margin: 0.4rem 0 0;
        }
        .more-avatarUrl{
          margin-top: 0.36rem;
        }
      }
    }
    .fabulous-title {
      text-align: center;
      color: #595757;
    }
    .img_wrap{
      display: flex;
      flex-wrap: wrap;
    }
    .img_wrap {
      margin-left: -0.1rem;
      .vis_div{
        display: flex;
        align-items: center;
        padding: 0.02rem 0 0.02rem 0.02rem;
        height: 0.46rem;
        background: #f7f7f7;
        border-radius: 90px;
        margin-left: 0.1rem;
        margin-top: 0.2rem;
        .vis_img{
          width: 0.42rem;
          height: 0.42rem;
          border-radius: 50%;
        }
        p{
          font-size: 0.22rem;
          padding: 0 0.2rem 0 0.1rem;
          color: #595757;
        }
      }
    }
    .avatarUrl {
      width: 0.55rem;
      height: 0.55rem;
      margin-left: 0.1rem;
      // object-fit: cover;
      margin-top:0.18rem;
      border-radius: 50%;
    }
    .more-avatarUrl {
      margin-top: 0.4rem;
      .more_wrap{
        display: inline-block;
      }
      .more-btn {
        color: #13367b;
      }
      .icon {
        display: inline-block;
        transform: rotate(90deg);
        color: #13367b;
        margin-left: 0.16rem;
      }
    }
    .dianzan {
      text-align: center;
      font-size: 0.3rem;
      font-weight: bold;
      margin-top: 0.32rem;
      color: #283e86;
    }
    .userName {
      padding: 0.4rem 0;
      .more-avatarUrl {
        text-align: center;
      }
    }
  }
</style>
<style scoped lang="scss">
  ::after,::before{
    box-sizing: border-box;
  }
  @keyframes rotate360 {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .u-heart-theme:after,
  .u-heart-theme .dot-box,
  .u-heart-theme .dot-box:after,
  .u-heart-theme .dot-box i:after,
  .like_img,.like_img img,
  .u-heart-theme .heart,
  .u-heart-theme .heart:before,
  .u-heart-theme .heart:after,
  .u-heart-theme .icon-dianzan:before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  .u-heart-theme {
    border-radius: 50%;
    height: 100px;
    width: 100px;
    position: relative;
    margin: 0 auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }

  .u-heart-theme:after {
    content: "";
    border-radius: 50%;
    height: 50%;
    width: 50%;
    background-color: currentColor;
    -webkit-box-shadow: 0px 0px 4px 0px rgba(8, 8, 8, 0.2);
    box-shadow: 0px 0px 4px 0px rgba(8, 8, 8, 0.2);
  }

  .u-heart-theme .dot-box {
    -webkit-animation: rotate360 2s forwards infinite linear;
    animation: rotate360 2s forwards infinite linear;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .u-heart-theme .dot-box:before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 50%;
    opacity: 0.2;
    top: 0;
    left: 0;
    border: 1px solid currentColor;
  }

  .u-heart-theme .dot-box:after {
    content: "";
    border-radius: 50%;
    height: 75%;
    width: 75%;
    top:50%;
    left:50%;
    right: auto;
    bottom: auto;
    transform:translate(-50%,-50%);
    border: 1px solid #3dbfdf;
    border-color: currentColor;
    opacity: 0.4;
  }

  .u-heart-theme .dot-box i {
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    border: 1px solid #3dbfdf;
    border-color: currentColor;
    opacity: 0.2;
  }

  .u-heart-theme .dot-box i:after {
    content: "";
    z-index: 2;
    display: inline-block;
    background: currentColor;
    border-radius: 50%;
    height: 4px;
    width: 4px;
  }

  .u-heart-theme .dot-box i:nth-child(1) {
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }

  .u-heart-theme .dot-box i:nth-child(2) {
    top: 66%;
    left: 0;
    -webkit-transform: translateX(-25%) translateY(-50%);
    transform: translateX(-25%) translateY(-50%);
  }

  .u-heart-theme .dot-box i:nth-child(3) {
    top: 66%;
    right: 0;
    -webkit-transform: translateX(25%) translateY(-50%);
    transform: translateX(25%) translateY(-50%);
  }

  .u-heart-theme .heart {
    z-index: 2;
    -webkit-animation-name: scale1;
    animation-name: scale1;
    -webkit-animation-duration: 0.8s;
    animation-duration: 0.8s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    border-radius: 50%;
    height: 30%;
    width: 30%;
  }

  .u-heart-theme .heart.good:before,
  .u-heart-theme .heart.good:after {
    background-color: #c9c9c9;
  }

  .u-heart-theme .heart:before,
  .u-heart-theme .heart:after {
    content: "";
    width: 12px;
    height: 18px;
    background-color: #fff;
    border-radius: 6px 6px 0 0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
  }

  .u-heart-theme .heart:after {
    right: 13px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }

  .u-heart-theme .heart:before {
    left: 13px;
  }

  .u-heart-theme .icon-dianzan {
    z-index: 2;
    -webkit-animation-name: scale1;
    animation-name: scale1;
    -webkit-animation-duration: 0.8s;
    animation-duration: 0.8s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 30px;
    color: #fff;
    display: inline-block;
    position: relative;
  }

  .u-heart-theme .icon-dianzan.good {
    color: #c9c9c9;
  }

  .u-heart-theme .icon-dianzan:before {
    width: 30px;
    height: 35px;
    display: inline-block;
    z-index: 3;
  }
  .like_img img{
    z-index: 2;
    width: 30px;
    height: 30px;
    display: block;
    transform: scaleY(-0.02rem);
  }
</style>
